<template>
    <div>
        <apexchart type="line" height="200" :options="chartOptions" :series="series" v-if="graphColorsLoaded"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
const platform = process.env.VUE_APP_Platform ?? "DTN";
const graphColors = require(`@/assets/scss/platformScss/${platform}/graphs.scss`);

export default {
    data(){
        return {
            graphColors
        }
    },
    created(){
        this.populateMarketChangeSeriesData();
    },
    methods: {
        ...mapActions('graphs', ['populateMarketChangeSeriesData']),
    },
    computed:{
        ...mapState('graphs', ['marketChangeSeriesData']),
        ...mapState('livePrices', ['refreshSecondsLeft']),
        series: {
            get: function(){
                let data = []

                if (this.marketChangeSeriesData){
                    data = [
                        {
                            name: "Market Change",
                            data: this.marketChangeSeriesData.changes
                        }
                    ]
                }

                return data
            }
        },
        graphColorsLoaded() {
            return this.graphColors != null
        },
        chartOptions: function(){
            return {
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 2000,
                    animateGradually: {
                        enabled: true,
                        delay: 100,
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 100,
                    },
                },
                chart: {
                    fontFamily: 'Lato, sans-serif',
                    selection: {
                        enabled: true,
                        type: 'x',
                        fill: {
                            color: this.graphColors.green,
                            opacity: 0.1
                        },
                        stroke: {
                            width: 1,
                            dashArray: 1,
                            color: this.graphColors.green,
                            opacity: 0.4
                        }
                    },
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            selection: false,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            pan: false,
                            reset: false
                        },
                        autoSelected: 'zoom'
                    },
                    width: '100%'
                },
                colors: [this.graphColors.MarketChangeGraphColor1, this.graphColors.MarketChangeGraphColor2, this.graphColors.MarketChangeGraphColor3],
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                },
                markers: {
                    size: 0
                },
                noData: {
                    text: "No Data for that criteria",
                    align: "center",
                    verticalAlign: "middle"
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                tooltip: {
                    x: {
                        format: 'HH:mm'
                    }
                },
                xaxis: {
                    axisBorder: {
                        show: true,
                        color: this.graphColors.lightGrey
                    },
                    labels: {
                        offsetX: -2,
                        dateTimeFormatter:{
                            hour: 'H'
                        }
                    },
                    type: 'datetime',
                    tooltip: {
                        enabled: false
                    },
                    categories: this.marketChangeSeriesData.times
                },
                yaxis: {
                    min: -Math.max(Math.abs(Math.min(...this.marketChangeSeriesData.changes)), Math.abs(Math.max(...this.marketChangeSeriesData.changes))) - 0.1,
                    max: Math.max(Math.abs(Math.min(...this.marketChangeSeriesData.changes)), Math.abs(Math.max(...this.marketChangeSeriesData.changes))) + 0.1,
                    axisBorder: {
                        show: true,
                        color: this.graphColors.lightGrey
                    }
                }
            }
        },
    },
    watch: {
        chartOptions(){},
        refreshSecondsLeft(val){
            if (val === 0) {
                this.populateMarketChangeSeriesData();
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>